export const shieldContractContent = {
  header: {
    title: "ENFINITY LIMITED – ENFINISHIELD TERMS OF SERVICE",
    subtitle: "Global Content Protection And Monetization Agreement",
    logo: "shield",
  },
  consentBlock: {
    title: "EnfiniShield rights also granted?",
    valuePath: "true",
  },
  signatureBlock: {
    serviceName: 'EnfiniCore ("On behalf of Enfinity Limited")',
    postAcquiredConsent: {
      title: "Exclusive EnfiniBoost rights also granted:",
      valuePath: "user.video_distribution",
    },
  },
  paragraphs: [
    {
      text: "This EnfiniShield User Agreement (herein referred to as the \"Agreement\") is entered into by and between Enfinity Limited (\"Enfinity Limited\", \"we\", \"us\"), doing business as EnfiniShield, and the undersigned producer/content owner (\"Producer\", \"you\", \"your\"), who is registering for the service and has agreed to the terms of this Agreement, effective as of today's date {{currentDate}}.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "1. Scope",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 170,
    },
    {
      text: "1. The purpose of this Agreement is to grant exclusive, non-transferable, irrevocable Content Licensing rights to Enfinity Limited in order to legally perform its services and comply with the policies in place that moderate EnfiniShield and its use of sensitive third-party tools, including but not limited to: YouTube Content ID, Facebook Rights Manager, Snapchat Discovery, Microsoft feeds. You acknowledge that without these rights, it is impossible for us to legally perform our service. Our service in this instance is to protect and monetize your catalog of content through a combination of publishing and royalty claiming techniques on various third-party platforms.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "2. You still retain ownership of all your content, videos, and intellectual property. However, upon registration submission, you forfeit all rights to licensing the content submitted to other companies in the future, and Enfinity Limited will uphold its right as the exclusive license holder in order to comply with usage guideline policies mandated to us by third-party platforms; otherwise, this service is impossible to perform.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "3. By agreeing to the terms set forth, you are allowing Enfinity Limited to exclusively manage and monetize your video content internally and externally without limitation.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "2. Content for Licensing",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 170,
    },
    {
      text: "1. The \"Content\" means the content produced and posted to your social media channels that are being submitted upon registration and submission (examples include YouTube, Instagram, TikTok, Facebook, Douyin, Kuaishou, etc.), as well as any other content that we and you agree in writing to include in this Agreement from time to time.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "2. You may deliver additional content to your point person at EnfiniShield or by writing to copyright@enfinity.com and attaching the content you desire to submit as a file or via cloud storage with your provider of choice, e.g. DropBox, OneDrive, etc.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "3. At the time of this Agreement, the social video content has been submitted by you to Enfinity Limited for exclusive, non-transferrable, irrevocable content management services; including but not limited to digital rights management on YouTube and other platforms.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "4. All content on the pages set forth on the onboarding registration submission form has been submitted to Enfinity Limited for exclusive, non-transferrable, irrevocable licensing and will be subject to review for its usage within EnfiniShield and its Network.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "Please note that not all content may be eligible, and that EnfiniShield's team will review the submitted content herein to ensure third-party platform compliance.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "3. Fees and Payments",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 170,
    },
    {
      text: "1. For the first one hundred USD generated in a given month, Enfinity Limited will deduct a free services fee equal to this amount because of its decision to absorb all of the cost, labour, and risk in allowing you to freely register to its services. Afterward, along with five percent of the revenues generated as a content hosting fee (at the moment, Dropbox Premium), Enfinity Limited will automatically split the recouped revenue with the Producer in accordance with the revenue-sharing rates of this agreement, which are subject to change from time-to-time as per the Company's discretion and market conditions. For YouTube partner ad-revenues generated by YouTube's algorithmic claiming, the baseline revenue-sharing tier after any applicable service or administration fee is half to you and half to Enfinity Limited, along with an additional five percent to you (which is separate to the existing share) if your content is selected, at our sole and absolute discretion, for any special promotional or anchor campaign on our supported platforms, which may change from time to time.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "2. Payments are sent out within 14-days of Facebook or AdSense (if applicable per your content's platform-specific eligibility) disbursing the funds to us. If your content generated revenue in January, this revenue will be paid on or around February 28th.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "3. You will be responsible for taxes and reporting your revenues in your own respective country, and Enfinity Limited will not be held liable in any way in the event you neglect your duties to report whatever ought to be reported.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "4. In the event that ads are displayed on other channels containing copyrighted content from multiple claimants, you will be entitled to collect a share of the divided revenue with other rights holders (e.g. Music Publishers) after appropriate splits have taken place.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "5. Enfinity Limited is not obligated to pay you for any re-uploaded videos that fall outside of YouTube's content delivery requirements and criteria policies, including content that falls below YouTube's required minimum lengths for algorithmic claiming.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "6. The Network (Enfinity Limited / EnfiniShield) will have no obligation to pay any amounts, and is permitted to deduct or withhold any amounts owed, determined or reasonably suspected by Enfinity Limited, in its sole discretion, to have resulted from:",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "(a) Action Fraud, including without limitation through any clicks originating from Talent's IP addresses or computers under Talent's control, solicited by payment of money, false representation or request for end users to click on Ads, or",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "(b) fraudulent, misleading or false activities or activities that Enfinity Limited or its primary platforms, such as YouTube and Facebook, believe to be fraudulent or misleading or in violation of either of their respective terms of service, guidelines, rules, or privacy policies.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "7. Enfinity Limited reserves the right to withhold or deduct any payments, pending its reasonable investigation of any of the foregoing or any breach of this Agreement.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "8. Conflict resolution fees will be charged when Enfinity Limited argues and handles a disputed asset resolution on your behalf if you attempt to work with multiple content claiming providers at once, thus causing extra administrative work for EnfiniShield. If in any given month there is one or more of these events, you will be charged an additional five percent of the partner ad-revenue generated in that given month.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "4. Contract Period",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 170,
    },
    {
      text: "1. The period of this Agreement will be for 24-months with automatic renewals thereafter, unless you terminate this Agreement with 90-days written notice prior to the renewal date in form of legal writing to copyright@enfinity.com.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "2. Should you decide to end this Agreement, we agree to stop uploading/monetizing any new content you upload after the termination date. You acknowledge and understand that previously activated reference files will remain exclusively licensed to us, as required by the third-party platforms we partner with, making it possible to provide this service in the first place.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "3. If you choose to terminate this Agreement, we will ensure your final payment is processed within 30 days of termination. By ending your Agreement with Enfinity Limited or any of our affiliates, you agree that no further payments will be made to you after the termination date.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "4. The content, video assets, and intellectual property that you created, published, and/or generated prior to, and during the tenure of your Partnership with the Company will remain active, and Enfinity Limited's exclusive content license (via EnfiniShield) will remain non-transferable and active within its Content Management Systems, including but not limited to publishing and protection on YouTube, Facebook, Microsoft, and Snapchat discovery. The exclusive license will survive the termination of this Agreement and will remain non-transferable for all content submitted upon registration and submission.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "5. Enfinity Limited will retain its exclusive, non-transferable content license rights after termination for all content submitted prior to the effective date of your termination. If you decide to work with another content claiming Company, Enfinity Limited will keep its right to manage the content internally and externally within its systems, including but not limited to: Content ID, Rights Manager, Microsoft Feeds, and tools of this nature.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "5. Enfinity Limited's Rights and Licenses",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 170,
    },
    {
      text: "You hereby grant to each of the following exclusive and non-transferable rights:",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "1. The exclusive right and license to use, reproduce, digitize, encode, modify, monetize, re-format, transmit, re-broadcast, repurpose the Content and collect revenues from the protection, publishing, and management of the Content on YouTube, Facebook, Snapchat, TikTok, Microsoft, and others from time to time. You will be paid your share of the partner ad-revenue on a monthly basis for as long as this Agreement is active.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "2. The exclusive right and license to administer content claiming, including without limitation, Content ID claims, and monetization services for the Content across third-party platforms. If you have no existing presence on a promotional platform (i.e. Snapchat, Microsoft, Facebook, YouTube), you acknowledge and provide us the rights to publish, claim against piracy, and monetize your library on such platforms and pay you for doing so in accordance with the revenue shares in section 3 as promotional royalties. You agree that the Company withholds the right to not perform this service at any time.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "3. The ability to sub-license the content internally or externally to third-party publishing partners for the purpose of monetization and content protection benefit for you.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "4. The ability to create an anchor account, or first account, on platforms where your presence is not currently established in order to prevent pirates from wrongfully uploading your catalog and claiming first rights. The revenue share for this is outlined as a promotional royalty in section 3.1. Royalties will continue to be paid to us from anchor accounts post-termination, and a buyout offer will be made to you for sole ownership, typically at a multiple of twelve the gross ARR we have generated on your behalf.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "6. Ownership/Clearances/Warranties",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 170,
    },
    {
      text: "1. You retain full ownership of your Content.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "2. You must have all the necessary rights and clearances in connection with the Content, and you have the legal right to grant the rights to us. By registering, digi-signing, and submitting your Content and rights to Enfinity Limited, you hereby absorb all legal liability in the event of legal proceedings relating to the Content you submitted for management.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "3. You warrant and represent that the Content does not infringe on the rights of any third party or violate third-party platform rules, including YouTube's Terms of Use. Additionally, you agree to defend, indemnify and hold harmless Enfinity Limited for any and all claims to the contrary.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "7. Other Provisions",
      fontSize: 13,
      x: 15,
      fontWeight: "bold",
      maxWidth: 170,
    },
    {
      text: "1. You agree to keep the terms of this Agreement confidential.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "2. This Agreement is governed and construed according to Hong Kong law, and by signing, you are agreeing to submit to the jurisdiction of Hong Kong.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "3. You and Enfinity Limited waive all rights to a jury trial, instead electing that the dispute be resolved by a judge. Additionally, both parties agree that any and all disputes or claims that have arisen or may arise between either party (Enfinity Limited and You, the 'Producer), including common law claims and those based in contract, tort, fraud, misrepresentation or any other equitable or legal theory, and relating in any way to this website, its services or these terms will be resolved only by and through confidential final and binding arbitration, rather than in any court, except that You may only assert claims in small claims court if your claims qualify and so long as the matter remains in such court and advances only on an individual (non-class, non-representative) basis.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "4. Upon submission of acceptance of this User Agreement, I agree that all information in this form is true and accurate. I also agree that if I am under 18, my parent/guardian will sign this User Agreement and absorb all legal liability for this User Agreement.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "5. You agree to, and are hereby bound to, our Terms of Service, found here, which may be amended from time to time. Continued use of our service is constituted as acceptance to such amendments. These terms include the exclusive, explicit, non-transferable content licensing rights to the content contractually submitted by you to Enfinity Limited. These rights remain even if you terminate this Agreement, in accordance with section 4 of this Agreement.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "6. Electronic communication is a sufficient method to notify a party.",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
    {
      text: "7. By joining and accepting our registration forms, you agree as follows: 'I understand I am granting a non-transferable, irrevocable, fully exclusive license to all of the content submitted on the social media pages I am submitting, and that Enfinity Limited (operating as EnfiniShield), and any other of its authorized divisions without limitation, may represent and manage this content on my behalf without limitation.'",
      fontSize: 13,
      x: 15,
      fontWeight: "normal",
      maxWidth: 170,
    },
  ],
};
